import { type Nullable } from '../../types/common'
import BaseComponent from '../base-component/base-component'

class ProductBreadcrumbs extends BaseComponent {
  collectionLink: Nullable<HTMLLinkElement>

  constructor() {
    super()

    this.collectionLink = this.querySelector('[data-collection-link]')
  }

  setCollectionPage = (collectionPage: string): void => {
    if (collectionPage) {
      const data = JSON.parse(collectionPage)

      if (this.collectionLink) {
        this.collectionLink.href = data.url
        this.collectionLink.ariaLabel = data.title
        this.collectionLink.textContent = data.title
      }
    }
  }
}

export default ProductBreadcrumbs
